import { useContext } from 'react';
import AlertContext from '@/context/Alert';

const useAlert = () => useContext(AlertContext);

export default useAlert;